import { redirect } from "@tanstack/react-router";
import { useAppStore } from "@/lib/store";

/**
 * Reusable auth guard - prevents double store reads by using single state reference
 */
export const authGuard = async () => {
  const store = useAppStore.getState();

  if (!store.authInitialized) {
    await store.initAuth();
  } else if (store.isAuthenticated) {
    await store.refreshUser();
    await store.loadUserData();
  }

  if (!store.isAuthenticated) {
    throw redirect({ to: "/login" });
  }

  return store;
};
